export * from './ArchiveBoxIcon';
export * from './ArchiveBoxIcon16Light';
export * from './ArchiveBoxIcon16Regular';
export * from './ArchiveBoxIcon16Solid';
export * from './ArchiveBoxIcon20Light';
export * from './ArchiveBoxIcon20Regular';
export * from './ArchiveBoxIcon20Solid';
export * from './ArchiveBoxIcon24Regular';
export * from './ArchiveBoxIcon24Solid';
export * from './ArchiveBoxIcon32Regular';
export * from './ArchiveBoxIcon64Regular';
